import _ from 'lodash'
import {ref, computed} from 'vue'
import {useRoute} from 'vue-router'
import {getReportInspection, getReportInspectionFields, getReportInspectionField} from '@api'

// reportInpection
// - 2024.04.02
const reportInspection = ref(null)

// reportInspectionFields
// - 2024.10.24
const reportInspectionFields = ref({})
// reportInpectionFieldsTitle
// - 2024.10.24
// const reportInspectionFieldsTitle = ref(null)

// hasAttachmentMaintenceImages
// - 2024.10.29
// - has attachment maintence images
const hasAttachmentMaintenceImages = computed({
  get () {
    return !!(reportInspection.value
      && reportInspection.value.attachment
      && reportInspection.value.attachment.maintenance_images)
  },
})

// hasAttachmentMileageAnalysisBasis
// - 2024.10.29
// - has attachment mileage analysis basis
const hasAttachmentMileageAnalysisBasis = computed({
  get () {
    return !!(reportInspection.value
      && reportInspection.value.attachment
      && reportInspection.value.attachment.other_mileage_analysis_criteria_images)
  },
})

// hasAttachmentAccidentRecord
// - 2024.10.29
// - has attachment accident record
const hasAttachmentAccidentRecord = computed({
  get () {
    return !!(reportInspection.value
      && reportInspection.value.attachment
      && reportInspection.value.attachment.insurance_images)
  },
})

// * * * Included * * *
// | #  | Diagram Point               | Name          |
// |----|-----------------------------|---------------|
// | 1  | Hood                        | 机盖           |
// | 2  | Front Right Fender          | 右前翼子板      |
// | 3  | Front Right Door            | 右前门          |
// | 4  | Rear Right Door             | 右后门         |
// | 5  | Rear Right Fender           | 右后翼子板     |
// | 6  | Trunk (Left)                | 后尾门 (左)    |
// | 7  | Trunk Right                 | 后卫们 - 右    |
// | 7  | Rear Left Fender            | 左后翼子板     |
// | 8  | Rear Left Door              | 左后门         |
// | 9  | Front Left Door             | 左前门         |
// | 10 | Front Left Fender           | 左前翼子板     |
// | 11 | Roof                        | 车顶           |
//
// * * * Not inlcuded * * *
// | #  | Diagram Point               | Name          |
// |----|-----------------------------|---------------|
// | 1  | Left Side A-Pillar Outer    | 左侧A柱外侧     |
// | 2  | Left Side Sill Outer        | 左侧底边梁外侧  |
// | 3  | Left Side C-Pillar Outer    | 左侧C柱外侧    |
// | 4  | Left Side D-Pillar Outer    | 左侧D柱外侧    |
// | 5  | Right Side D-Pillar Outer   | 右侧D柱外侧    |
// | 6  | Right Side C-Pillar Outer   | 右侧C柱外侧    |
// | 7  | Right Side Sill Outer       | 右侧底边梁外侧  |
// | 8  | Right Side A-Pillar Outer   | 右侧A柱外侧    |

// diagramPointHood
// - 2024.04.15
// - Hood
const diagramPointHood = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '机盖',
      })
      : null
  },
})

// diagramPointFenderFrontRight
// - 2024.04.15
// - Front Right Fender
const diagramPointFenderFrontRight = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '右前翼子板',
      })
      : null
  },
})

// diagramPointDoorFrontRight
// - 2024.04.15
// - Front Right Door
const diagramPointDoorFrontRight = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '右前门',
      })
      : null
  },
})

// diagramPointDoorRearRight
// - 2024.04.15
// - Rear Right Door
const diagramPointDoorRearRight = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '右后门',
      })
      : null
  },
})

// diagramPointFenderRearRight
// - 2024.04.15
// - Rear Right Fender
const diagramPointFenderRearRight = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '右后翼子板',
      })
      : null
  },
})

// diagramPointTrunk
// - 2024.04.15
// - Trunk (left)
const diagramPointTrunk = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '后尾门',
      })
      : null
  },
})

// diagramPointTrunkRight
// - 2024.12.11
// - Trunk Right
const diagramPointTrunkRight = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '后尾门（右）',
      })
      : null
  },
})

// diagramPointFenderRearLeft
// - 2024.04.15
// - Rear Left Fender
const diagramPointFenderRearLeft = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '左后翼子板',
      })
      : null
  },
})

// diagramPointDoorRearLeft
// - 2024.04.15
// - Rear Left Door
const diagramPointDoorRearLeft = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '左后门',
      })
      : null
  },
})

// diagramPointDoorFrontLeft
// - 2024.04.15
// - Front Left Door
const diagramPointDoorFrontLeft = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '左前门',
      })
      : null
  },
})

// diagramPointFenderFrontLeft
// - 2024.04.15
// - Front Left Fender
const diagramPointFenderFrontLeft = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '左前翼子板',
      })
      : null
  },
})

// diagramPointRoof
// - 2024.04.15
// - Roof
const diagramPointRoof = computed({
  get () {
    const points = reportInspection.value
      && reportInspection.value.paint
      && reportInspection.value.paint.length
      ? reportInspection.value.paint
      : null

    return points && points.length
      ? _.find(points, {
        name: '车顶',
      })
      : null
  },
})

// reportFieldsByPartName
// - 2024.10.24
function reportFieldsByPartName (partName) {
  return reportInspectionFields.value[partName] || null
}

// useReportInspection
// - 2024.03.28
export function useReportInspection () {
  return {
    reportInspection,
    loadReportInspection,
    loadReportInspectionFields,
    diagramPointHood,
    diagramPointFenderFrontRight,
    diagramPointDoorFrontRight,
    diagramPointDoorRearRight,
    diagramPointFenderRearRight,
    diagramPointTrunk,
    diagramPointFenderRearLeft,
    diagramPointDoorRearLeft,
    diagramPointDoorFrontLeft,
    diagramPointFenderFrontLeft,
    diagramPointRoof,
    reportFieldsByPartName,
    hasAttachmentMaintenceImages,
    hasAttachmentMileageAnalysisBasis,
    hasAttachmentAccidentRecord,
    diagramPointTrunkRight,
    loadReportInspectionField,
  }
}

// loadReportInspection
// - 2024.04.02
async function loadReportInspection ({params} = {}) {
  try {
    const route = useRoute()
    const carId = route.params.id
    const business = route.params.business

    const rb = await getReportInspection({
      params: {
        vehicle_inspection_report_id: 2,
        module_id: carId,
        business: business,
        ...Object.fromEntries(Object.entries(route.query).filter(([k]) => k !== 'type')),
        ...(params || {}),
      },
    })

    reportInspection.value = rb
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// loadReportInspectionFields
// - 2024.10.24
async function loadReportInspectionFields ({params} = {}) {
  try {
    if (!params || !params['part_name']) {
      throw new Error('[aborted] missing `part_name`')
    }

    const route = useRoute()
    const carId = route.params.id
    const business = route.params.business

    const rb = await getReportInspectionFields({
      params: {
        vehicle_inspection_report_id: 2,
        module_id: carId,
        business: business,
        ...route.query,
        ...(params || {}),
      },
    })

    reportInspectionFields.value[params.part_name] = rb
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// loadReportInspectoinField
// - 2024.12.19
// - Load report inspection field
async function loadReportInspectionField ({params} = {}) {
  try {
    const rb = await getReportInspectionField({
      params,
    })

    return rb
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}
